module.exports = __webpack_public_path__ + "static/media/whatsapp-icon-white.4b213c1d.svg";